export enum IconSlug {
  CHAT = 'chat',
  STAR = 'star',
}

export const slugs = {
  chat: [IconSlug.CHAT],
  star: [IconSlug.STAR],
};
